import { Spin, Row } from 'antd';
import { spin } from './style';

const LoadingSpin = () => (
  <Row justify="center" align="middle" style={spin}>
    <Spin size="large" />
  </Row>
);
export default LoadingSpin;
